import Box from '@material-ui/core/Box'
import { Theme } from '@material-ui/core/styles/createTheme'
import makeStyles from '@material-ui/core/styles/makeStyles'
import Typography from '@material-ui/core/Typography'
import Skeleton from '@material-ui/lab/Skeleton'
import React, { useContext } from 'react'

import colorContext from '../../../../Context/colorContext'

export default function SkeletonNews(): JSX.Element {
  const { colors } = useContext(colorContext)
  const useStyles = makeStyles((theme: Theme) => ({
    main: {
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
      backgroundColor: colors.colorBackground,
      alignItems: 'center',
      padding: '49px 5px',
    },
    textTitle: {
      position: 'relative',
      textTransform: 'uppercase',
      fontFamily: 'Roboto',
      padding: '10px 0px 0px 3px',
      marginBottom: 5,
      fontWeight: 'bold',
      color: colors.textBody,
      left: 8,
      fontSize: theme.typography.pxToRem(36),
      '&::after': {
        content: '""',
        display: 'block',
        width: 4,
        height: 30,
        backgroundColor: colors.accentColor,
        position: 'absolute',
        bottom: 11,
        marginLeft: -14,
        left: 5,
      },
      [theme.breakpoints.down('xs')]: {
        fontSize: theme.typography.pxToRem(28),
        marginBottom: 30,
        '&::after': {
          bottom: 4,
        },
      },
    },
    card: {
      width: '100%',
      height: 374,
      borderRadius: 0,
      position: 'relative',
    },
    tagName: {
      fontSize: 13,
      textTransform: 'capitalize',
      height: 30,
      background: colors.badgeColor,
      color: colors.textAccentColor,
      fontWeight: 700,
      display: 'flex',
      alignItems: 'center',

      padding: '5px 16px',
      width: 'max-content',
      position: 'absolute',
      marginTop: -16,
    },
    tagDate: {
      height: 24,
      color: colors.accentColor,
      fontWeight: 500,
      display: 'flex',
      alignItems: 'center',
      paddingRight: 20,
      lineHeight: 16,
      fontSize: 14,
      width: 'max-content',
      marginTop: 33,
    },
    text: {
      fontWeight: 800,
      fontSize: theme.typography.pxToRem(18),
      color: colors.textAccentColor,
    },
    boxNews: {
      width: '100%',
      display: 'flex',
      justifyContent: 'space-between',
      flexWrap: 'wrap',
      cursor: 'pointer',
      [theme.breakpoints.down('xs')]: {
        justifyContent: 'center',
      },
    },
    newSecondary: {
      margin: '0px 8px',
      display: 'flex',
      justifyContent: 'space-between',
      cursor: 'pointer',
      '@media (max-width:1054px)': {
        flexDirection: 'column',
      },
    },
    button: {
      maxWidth: 360,
      width: '100%',
      marginTop: 28,
      height: 42,
      borderRadius: 25,
      backgroundColor: colors.colorWithoutGradient,
      alignSelf: 'center',
      color: colors.accentColor,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      textDecoration: 'none',
      textTransform: 'uppercase',
      '&:hover': {
        backgroundColor: colors.colorWithoutGradient,
        color: '#fff',
      },
    },
    textList: {
      marginRight: 8,
      fontSize: theme.typography.pxToRem(18),
      fontWeight: 700,
      marginLeft: 8,
      textTransform: 'uppercase',
      color: colors.accentColor,
      '&:hover': {
        color: colors.textAccentColor,
      },
      [theme.breakpoints.down('xs')]: {
        fontSize: theme.typography.pxToRem(14),
      },
    },
    newsPrimary: {
      maxWidth: 600,
      width: '100%',
      margin: '15px 8px',
      [theme.breakpoints.only('md')]: {
        maxWidth: '48%',
      },
      [theme.breakpoints.down('md')]: {
        width: '100%',
        maxWidth: 'initial',
      },
      [theme.breakpoints.down('xs')]: {
        width: '100%',
      },
    },
    line: {
      display: 'none',
      [theme.breakpoints.down('md')]: {
        display: 'block',
      },
    },
    box: {
      display: 'flex',
      alignItems: 'center',
      marginBottom: '20px',
      justifyContent: 'space-between',
      [theme.breakpoints.down('xs')]: {
        justifyContent: 'center',
      },
    },
    link: {
      textDecoration: 'none',
    },
  }))
  const classes = useStyles()

  return (
    <Box className={classes.main}>
      <Box display="flex" maxWidth="1320px" width="100%" flexDirection="column">
        <Box className={classes.box}>
          <Typography className={classes.textTitle} variant="h5" component="h2">
            Notícias
          </Typography>
        </Box>
        <Box className={classes.boxNews}>
          {Array.from({ length: 2 }).map((_, index) => (
            <Box key={index} className={classes.newsPrimary}>
              <Box width="100%">
                <Skeleton width="100%" height="217px" />
              </Box>
            </Box>
          ))}
        </Box>
        <Box className={classes.newSecondary}>
          {Array.from({ length: 2 }).map((_, index) => (
            <Skeleton key={index} className={classes.newsPrimary} />
          ))}
        </Box>
        <a href="/noticias" className={classes.button} rel="noreferrer">
          <p className={classes.textList}>VEJA A LISTA COMPLETA DE NOTÍCIAS</p>
        </a>
      </Box>
    </Box>
  )
}
